import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { useIntl } from 'react-intl';
import messages from './messages';
const ConfirmBar = styled.div.withConfig({
  displayName: "WidgetHideConfirmBar__ConfirmBar",
  componentId: "ecxjxw-0"
})(["display:flex;align-items:center;gap:clamp(3px,0.8vw,6px);flex-shrink:0;"]);
const ConfirmPrompt = styled.span.withConfig({
  displayName: "WidgetHideConfirmBar__ConfirmPrompt",
  componentId: "ecxjxw-1"
})(["font-size:clamp(0.6875rem,2.2vw,0.8125rem);white-space:nowrap;"]);
const HideButton = styled(Button).withConfig({
  displayName: "WidgetHideConfirmBar__HideButton",
  componentId: "ecxjxw-2"
})(["&&{color:", ";border-color:", ";min-width:0;padding:2px 6px;font-size:clamp(0.625rem,2vw,0.75rem);}"], props => props.theme.palette.error.main, props => props.theme.palette.error.main);
const CancelButton = styled(Button).withConfig({
  displayName: "WidgetHideConfirmBar__CancelButton",
  componentId: "ecxjxw-3"
})(["&&{min-width:0;padding:2px 6px;font-size:clamp(0.625rem,2vw,0.75rem);}"]);
export const WidgetHideConfirmBar = ({
  onConfirm,
  onCancel
}) => {
  const {
    formatMessage
  } = useIntl();

  const handleConfirm = e => {
    e.stopPropagation();
    onConfirm();
  };

  const handleCancel = e => {
    e.stopPropagation();
    onCancel();
  };

  return /*#__PURE__*/React.createElement(ConfirmBar, {
    className: "widget-hide-confirm-bar"
  }, /*#__PURE__*/React.createElement(ConfirmPrompt, null, formatMessage(messages.hideWidgetConfirm)), /*#__PURE__*/React.createElement(HideButton, {
    size: "small",
    variant: "outlined",
    onClick: handleConfirm
  }, formatMessage(messages.hideWidget)), /*#__PURE__*/React.createElement(CancelButton, {
    size: "small",
    variant: "outlined",
    onClick: handleCancel
  }, formatMessage(messages.cancel)));
};
export default WidgetHideConfirmBar;